import { useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import { TbDeviceDesktopStar } from "react-icons/tb";

function Home() {
  const { showToast } = useOutletContext();
  const { profile } = useSelector((state) => state.portfolio);

  return (
    <section className="mx-auto flex min-h-[calc(100vh-96px)] max-w-7xl flex-col items-center justify-center px-5 text-center">
      
      <div className="group relative mb-6 inline-flex overflow-hidden rounded-2xl p-[1px] sm:rounded-full">
        
        <span className="absolute inset-[-1000%] opacity-70 transition-opacity duration-500 will-change-transform group-hover:opacity-100 bg-gradient-to-r from-indigo-400 via-purple-400 to-slate-400 sm:animate-[spin_3s_linear_infinite] sm:bg-[conic-gradient(from_90deg_at_50%_50%,#e2e8f0_0%,#818cf8_50%,#c084fc_75%,#e2e8f0_100%)]"></span>
        
        <div className="relative flex h-full w-full items-center justify-center gap-2 rounded-2xl bg-[#0a0f1c]/80 px-4 py-2 text-center text-xs backdrop-blur-xl sm:rounded-full sm:px-5 sm:text-sm">
          <TbDeviceDesktopStar className="shrink-0 text-[1.1rem] text-indigo-300" />
          <span className="bg-gradient-to-r from-slate-200 via-indigo-300 to-purple-300 bg-clip-text font-semibold tracking-wide text-transparent">
            Explore the full experience on desktop
          </span>
        </div>
      </div>

      <h1 className="max-w-4xl text-4xl font-bold tracking-tight text-white sm:text-5xl md:text-7xl">
        {profile.tagline}
      </h1>

      <p className="mt-6 max-w-2xl text-base leading-7 text-slate-400 sm:text-lg">
        {profile.subTitle}
      </p>

      <button
        onClick={() => showToast("info", "Welcome to my portfolio")}
        className="mt-8 rounded-full bg-white px-6 py-3 text-sm font-semibold text-slate-950 transition hover:scale-105 hover:bg-slate-200"
      >
        Test Toaster
      </button>
    </section>
  );
}

export default Home;